var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isGd == 'true')?_c('GdDevice',{attrs:{"apiHost":_vm.apiHost}}):_vm._e(),(_vm.isYLZ == 'true')?_c('YLZDevice',{attrs:{"apiHost":_vm.apiHost}}):_vm._e(),(_vm.isCP == 'true')?_c('CPDevice',{attrs:{"apiHost":_vm.apiHost}}):_vm._e(),(_vm.isGd != 'true' && _vm.isYLZ != 'true' && _vm.isCP != 'true')?_c('Device'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }